module.exports = __webpack_public_path__ + "images/category_lp/hobby/assessment_achievements/3_432911f4af4cbdd632d12b81b388646d.png";